import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { MessageService } from "primeng/api";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { CacheAssetsComponent } from "./cache-assets/cache-assets.component";
import { ColumnFilterComponent } from "./column-filter/column-filter.component";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { DialogComponent } from "./dialog/dialog.component";
import { FigureComponent } from "./figureComponent/figure.component";
import { BuildingIdPipe } from "./pipes/buildingIdPipe.pipe";
import { fakeArrayPipe } from "./pipes/fakeArray.pipe";
import { SurveyStatusComponent } from "./table/survey-status/survey-status.component";
import { TechnicalInfoQuestionComponent } from "./technical-info-question/technical-info-question.component";
import { TestComponent } from "./test/test.component";
import { ToastService } from "./toast.service";
import { UnitInfoComponent } from "./unit-info/unit-info.component";
import { VersionComponent } from "./version/version.component";
import { SurveyStatusButtonComponent } from "./table/survey-status-button/survey-status-button.component";
import { TopNavComponent } from "./top-nav/top-nav.component";
import { UserInfoComponent } from "./top-nav/user-info/user-info.component";
import { MatMenuModule } from "@angular/material/menu";
import { FilterableTableComponent } from "./table/filterable-table.component";
import { TooltipModule } from "primeng/tooltip";
import { AreaSelectorComponent } from "./area-selector/area-selector.component";
import { InputSwitchModule } from "primeng/inputswitch";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ToastModule,
    BrowserAnimationsModule,
    BreadcrumbModule,
    TableModule,
    DropdownModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    CheckboxModule,
    TooltipModule,
    InputSwitchModule,
  ],
  declarations: [
    BreadcrumbComponent,
    TestComponent,
    ConfirmDialogComponent,
    FigureComponent,
    TechnicalInfoQuestionComponent,
    UnitInfoComponent,
    DialogComponent,
    fakeArrayPipe,
    CacheAssetsComponent,
    VersionComponent,
    SurveyStatusComponent,
    BuildingIdPipe,
    ColumnFilterComponent,
    SurveyStatusButtonComponent,
    TopNavComponent,
    UserInfoComponent,
    FilterableTableComponent,
    AreaSelectorComponent,
  ],
  exports: [
    ToastModule,
    BreadcrumbComponent,
    BrowserAnimationsModule,
    BreadcrumbModule,
    TechnicalInfoQuestionComponent,
    UnitInfoComponent,
    DialogComponent,
    FigureComponent,
    TableModule,
    fakeArrayPipe,
    CacheAssetsComponent,
    VersionComponent,
    SurveyStatusComponent,
    BuildingIdPipe,
    ColumnFilterComponent,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    SurveyStatusButtonComponent,
    TopNavComponent,
    AreaSelectorComponent,
    MatMenuModule,
    InputSwitchModule,
  ],
  providers: [MessageService, ToastService],
  entryComponents: [ConfirmDialogComponent],
})
export class SharedModule {}
